module.exports = __webpack_public_path__ + "static/media/Walter F. Mondale - 1984.63a802f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Walter F. Mondale - 1984.jpg
// module id = 561
// module chunks = 0